import AppUtils from '@control-front-end/utils/utils';
import { call, select, put, takeLatest } from 'redux-saga/effects';
import { SEARCH, RequestStatus } from 'constants';
import api from '@control-front-end/common/sagas/api';

/**
 * Поиск событий, людей и тегов
 */
function* searchQuery({ payload, callback }) {
  const accounts = yield select((state) => state.accounts);
  const config = yield select((state) => state.config);
  const { filters, formId, query } = payload;
  const url = AppUtils.makeUrl(
    `/search/${accounts.active}/${encodeURIComponent(query)}`,
    {
      formId,
      filters,
    }
  );
  const { result, data } = yield call(api, {
    method: 'get',
    url,
  });
  if (result !== RequestStatus.SUCCESS) return;
  data.data.forEach((item) => {
    if (item.objType === 'user') {
      item.avatar = config.avatarPath.replace('{userId}', item.id);
    } else if (item.picture) {
      item.pictureUrl = AppUtils.makeAppUrl(`/download/${item.picture}`);
    }
    item.ownerAvatar = config.avatarPath.replace('{userId}', item.ownerId);
    if (item.ownerId === 0) item.ownerAvatar = config.systemUserAvatar;
  });
  if (callback) {
    callback(data.data);
  } else {
    yield put({ type: SEARCH.SUCCESS, payload: data.data });
  }
}

function* search() {
  yield takeLatest(SEARCH.REQUEST, searchQuery);
}

export default search;
